"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const foundations_1 = require("@airstudio/foundations");
const actions = require("./actions");
exports.fetch = (dispatch) => {
    return async () => {
        dispatch(actions.fetchRequest());
        try {
            const { data: { config } } = await foundations_1.Api.client.get('/config');
            dispatch(actions.fetchSuccess(config));
        }
        catch (error) {
            dispatch(actions.fetchFailure(foundations_1.Api.extractErrorMessage(error)));
            return false;
        }
        return true;
    };
};
//# sourceMappingURL=operations.js.map